import PropTypes from "prop-types";
import React, { lazy, Suspense } from "react";
import {Redirect, Route} from "react-router-dom";
import customHistory from "../../../common/history";
import {LANGUAGE} from "../../../common/i18n/locales/localeConstant";
import {getLanguage} from "../../../common/common";

const IntlWrapperProvider = lazy(() => import("../../../store/providers/IntlWrapperProvider"));

const LocalizedRouter = ({children, RouterComponent, defaultLanguage}) => {
    return (
        <RouterComponent history={customHistory}>
            <Route path="/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})">
                {({match, location}) => {
                    /**
                     * Get current language
                     * Set default locale to en if base path is used without a language
                     */
                    const params = match ? match.params : {};
                    let { lang = defaultLanguage || getLanguage().toLowerCase() } = params;
                    const { pathname, search } = location;
                    if (
                        !/^de-de$|^de-at$|^de-ch$|^it-it$|^fr-fr$|^nl-nl$|^en-gb$/.test(lang.toString().toLowerCase())
                    ) {
                        lang = LANGUAGE.EN;
                    }

                    // We use search to maintain the query parameters
                    const redirectUrl = (newPath) => newPath + (search ? search : "");

                    if ((lang.match("en-[a-z]{2}") && lang !== "en-gb") || lang === "en") {
                        return <Redirect to={redirectUrl(pathname.replace(/en-[a-z]{2}|en/, "en-gb"))} />;
                    }
                    if ((lang.match("it-[a-z]{2}") && lang !== "it-it") || lang === "it") {
                        return <Redirect to={redirectUrl(pathname.replace(/it-[a-z]{2}|it/, "it-it"))} />;
                    }
                    if ((lang.match("fr-[a-z]{2}") && lang !== "fr-fr") || lang === "fr") {
                        return <Redirect to={redirectUrl(pathname.replace(/fr-[a-z]{2}|fr/, "fr-fr"))} />;
                    }
                    if ((lang.match("nl-[a-z]{2}") && lang !== "nl-nl") || lang === "nl") {
                        return <Redirect to={redirectUrl(pathname.replace(/nl-[a-z]{2}|nl/, "nl-nl"))} />;
                    }
                    if (
                        (lang.match("de-[a-z]{2}") && !/de-de|de-at|de-ch/.test(lang.toString().toLowerCase())) ||
                        lang === "de"
                    ) {
                        return <Redirect to={redirectUrl(pathname.replace(/de-[a-z]{2}|de/, "de-de"))} />;
                    }
                    if (!/en-gb|nl-nl|fr-fr|it-it|de-de|de-ch|de-at/.test(lang.toString().toLowerCase())) {
                        return <Redirect to={"/"} />;
                    }
                    if (!pathname.toString().endsWith("/") && !search) {
                        return <Redirect to={redirectUrl(pathname + "/")} />;
                    }
                    if (lang && lang.split("-").length) {
                        document.documentElement.lang = lang.split("-")[0];
                    }
                    /**
                     * Return Intl provider with default language set
                     */
                    return (
                        <Suspense fallback={<div />}>
                            <IntlWrapperProvider locale={lang}>{children}</IntlWrapperProvider>
                        </Suspense>
                    );
                }}
            </Route>
        </RouterComponent>
    );
};

LocalizedRouter.propTypes = {
    children: PropTypes.any,
    RouterComponent: PropTypes.elementType,
    defaultLanguage: PropTypes.string,
};

export default LocalizedRouter;
